/**
 * populateChampionSelect — Fill debug <select> from playable roster (P3-22).
 */
import { listChampionKeys } from '../../domain/champions.js';
import { getChampionLobbyDetails } from './championLobbyCatalog.js';

const LABEL_EMOJI = {
  ashe: '🏹',
  garen: '🛡️',
  ryze: '🔮',
  annie: '🔥',
  sivir: '🗡️',
  lux: '✨',
  brand: '🔥',
  veigar: '😈'
};

export function populateChampionSelect(selectEl, roster = listChampionKeys()) {
  if (!selectEl) return 0;
  const current = selectEl.value;
  selectEl.innerHTML = roster.map((id) => {
    const details = getChampionLobbyDetails(id);
    const emoji = LABEL_EMOJI[id] || '👤';
    return `<option value="${id}">${emoji} ${details.name}</option>`;
  }).join('');
  if (roster.includes(current)) selectEl.value = current;
  return roster.length;
}
